module.exports = __webpack_public_path__ + "static/media/lock.1bb84396.svg";